import { Outlet } from "react-router-dom";
// import TechnicalErrorPage from "./components/NotFoundPage/TechnicalErrorPage";

const App = () => {
  //// Uncomment the line below to use a technical error page
  // return <TechnicalErrorPage />;
  return <Outlet />;
};

export default App;
